import { DatePipe } from "@angular/common";
import { Injectable, OnDestroy } from "@angular/core";
import { AlertController } from "@ionic/angular";
import { AlertInput } from "@ionic/core";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { ClientSettings } from "src/model/class/client-settings";
import { EnumStringConverter } from "src/components/shared-components/enum/enum-string-converter";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import {
  UserInvitationResponse,
  UserLoginRegistrationResponse,
  UserRequestResetPasswordResponse,
  UserSendInvitationResponse,
} from "src/components/shared-components/enum/enumLoginRegistrationResponse";
import { AccessResult } from "src/components/shared-components/enum/enumAccessControl";
import { HiLevelDataFormat } from "src/components/shared-components/enum/enumAddress";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";
import { PlantConfigurationExternal } from "src/model/interface/plant-configuration-external";
import { clientSettings } from "src/state/selectors/client-settings.selectors";
import { AccountService } from "./account.service";
import { EventService } from "./event.service";
import { LoggerService } from "./logger.service";
import { BuildingCreationResponse } from "src/components/shared-components/enum/enumBuilding";

@Injectable({
  providedIn: "root",
})

/**
 * Service for menaging popup
 */
export class AlertService implements OnDestroy, iTranslation, iEvent {
  private _logContext: string = "Alert.service";

  //#region Subcriptions to "_store.select(...)" Observables
  private _selectClientSettingsUserSub: Subscription = null;
  //#endregion

  private _translateSubscription: Subscription = null;
  private _currentClientSetting: ClientSettings = null;
  private _currentOkAlert: Promise<boolean> = null;
  private _currentDisconnectionAlert: HTMLIonAlertElement = null;
  private _currentCommandNotAvaibleAlert: HTMLIonAlertElement = null;
  private _currentIpNotAllowedAddress: HTMLIonAlertElement = null;
  private _currentAccessResult: HTMLIonAlertElement = null;
  private _currentPlantNameInsertAlert: boolean = false;

  private _isAlertDisconnectPresented: boolean = false;
  private _isAlertIpNotAllowedPresented: boolean = false;
  private _isAlertAccessResultPresented: boolean = false;
  private _isAlertCommandNotAvaiablePresented: boolean = false;
  private _isAlertOkPresented: boolean = false;
  //#region  Translation label //
  private _lblDisconnection: string = "";
  private _lblDisconnectionSubHeader: string = "";
  private _lblDisconnectionMessage: string = "";
  private _lblExit: string = "";
  private _lblConfirm: string = "";
  private _lblUndo: string = "";
  private _lblValue: string = "";
  private _lblOk: string = "";
  private _lblOps: string = "";
  private _lblSomethingWrong: string = "";
  private _lblAttention: string = "";
  private _lblDataUpdated: string = "";
  private _lblIpNotAllowedForConnectionMessage: string = "";
  private _lblNoOperation: string = "";
  private _lblCheckConnection: string = "";
  private _lblInteger: string = "";
  private _lblFloat: string = "";
  private _lblString: string = "";
  private _lblDate: string = "";
  private _lblDateTime: string = "";
  private _lblSetUID: string = "";
  private _lblNowYouCanEnter: string = "";
  private _lblErrorSend: string = "";
  private _lblSomeUserAlreadyAssociated: string = "";
  private _lblAllUserAlreadyAssociated: string = "";

  private _lblAccessResultAllowed: string = "";
  private _lblAccessResultDeniedExipred: string = "";
  private _lblAccessResultDeniedNotValidCard: string = "";
  private _lblAccessResultDeniedWrongTimeslot: string = "";
  private _lblAccessResultDeniedWrongCalendar: string = "";
  private _lblAccessResultDeniedLockCard: string = "";
  private _lblAccessResultDeniedWrongEnvironment: string = "";
  private _lblAccessResultDenied: string = "";
  private _lblWelcome: string = "";
  private _lblCommandNotAvaiable: string = "";
  private _lblError: string = "";
  private _lblNotSupportedRequestUpdate: string = "";
  private _lblPleaseEnterPlantName: string = "";
  private _lblName: string = "";
  private _lblNamePlantMandatory: string = "";
  private _lblSomethingWentWrongServerSync: string = "";
  private _lblInsertEmail: string = "";
  private _lblEmailSuccessfullySent: string = "";
  private _lblCheckInbox: string = "";
  private _lblAddressMayNotBeCorrect: string = "";
  private _lblEmailNotCorrect: string = "";
  private _lblCreateAccount: string = "";
  private _lblUserRegisteredSuccessfully: string = "";
  private _lblCheckMailboxToCompleteRegistrationProcess: string = "";
  private _lblRegisteredButNotActive: string = "";
  private _lblUserAlreadyPresentInPlatform: string = "";
  private _lblUserNotFoundOrWrongCredentials: string = "";
  private _lblMailAlreadyAssociated: string = "";
  private _lblOhNo: string = "";
  private _lblRegistrationSomethingWentWrong: string = "";
  private _lblResendEmail: string = "";
  private _lblClose: string = "";
  private _lblSentMailSuccessfully: string = "";
  private _lblCheckMailboxToCompleteChangePassword: string = "";
  private _lblChangePasswordSuccessfully: string = "";
  private _lblChangePasswordError: string = "";
  private _lblChangePasswordExpired: string = "";
  private _lblChangePasswordNotFound: string = "";
  private _lblInvitationSendSuccessfully: string = "";
  private _lblInvitationsSendSuccessfully: string = "";
  private _lblUserAlreadyAssociated: string = "";
  private _lblOperationOk: string = "";
  private _lblEmailSentSuccessfully: string = "";
  private _lblUserNotFound: string = "";
  private _lblTextMandatory: string = "";
  private _lblWrongConfigurationFileFormat: string = "";
  private _lblSomethingWentWrongSubText: string = "";
  private _lbluploadedSuccessfully: string = "";
  private _lblsomethingWentWrongSubText: string = "";
  private _lblUserMustResetPassword: string = "";
  private _lblEmailSentResetPassword: string = "";
  private _lblTaxCodeBadFormat: string = "";
  private _lblTaxCodeDuplicated: string = "";
  private _lblTaxCodeEmpty: string = "";
  private _lblVATDuplicated: string = "";

  //#endregion

  public _eventSubscriptions: Array<Subscription> = null;

  /**
   * Getter for disconnection presented
   */
  get isAlertDisconnectPresented(): boolean {
    return this._isAlertDisconnectPresented;
  }

  /**
   * Getter for IP Not allowed popup presented
   */
  get isAlertIpNotAllowedPresented(): boolean {
    return this._isAlertIpNotAllowedPresented;
  }

  constructor(
    private _alertController: AlertController,
    private _translateService: TranslateService,
    private _eventService: EventService,
    private _loggerService: LoggerService,
    private _store: Store,
    private _datePipe: DatePipe,
    private _accountService: AccountService
  ) {
    this.loadTranslation();
    this.subscribeTranslationEvent();
    this.subscribeSettingServiceData();
    this.subscribeEvents();
  }

  ngOnDestroy() {
    this._translateSubscription?.unsubscribe();

    this.unsubscribeStoreSelect();
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        for (
          let i = 0;
          i < document.getElementsByTagName("ion-alert").length;
          i++
        ) {
          document.getElementsByTagName("ion-alert")[i].dismiss();
        }
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  //#region Translation
  public loadTranslation(): void {
    this._translateService
      .get([
        "dictionary.exit",
        "dictionary.confirm",
        "dictionary.undo",
        "dictionary.value",
        "dictionary.ok",
        "dictionary.disconnection",
        "dictionary.disconnectionTitle",
        "dictionary.disconnectionMessage",
        "dictionary.ops",
        "dictionary.somethingWrong",
        "dictionary.attention",
        "dictionary.updatedData",
        "dictionary.ipNotAllowedForConnectionMessage",
        "dictionary.checkConnection",
        "dictionary.noOperation",
        "dictionary.accessResultAllowed",
        "dictionary.accessResultDeniedExpiredCard",
        "dictionary.accessResultDeniedNotValidCard",
        "dictionary.accessResultDeniedWrongTimeslot",
        "dictionary.accessResultDeniedWrongCalendar",
        "dictionary.accessResultDeniedLockCard",
        "dictionary.accessResultDeniedWrongEnvironment",
        "dictionary.accessResultDenied",
        "dictionary.welcome",
        "dictionary.commandNotAvaiable",
        "dictionary.enterInteger",
        "dictionary.enterFloat",
        "dictionary.enterString",
        "dictionary.chooseDate",
        "dictionary.chooseDateTime",
        "dictionary.error",
        "dictionary.notSupportedRequestUpdate",
        "dictionary.pleaseEnterPlantName",
        "dictionary.name",
        "dictionary.namePlantMandatory",
        "dictionary.somethingWentWrongServerSync",
        "dictionary.setUID",
        "dictionary.nowYouCanEnter",
        "dictionary.insertEmail",
        "dictionary.emailSuccessfullySent",
        "dictionary.checkInbox",
        "dictionary.addressMayNotBeCorrect",
        "dictionary.emailNotCorrect",
        "dictionary.emailCreateAccount",
        "dictionary.userRegisteredSuccessfully",
        "dictionary.checkMailboxToCompleteRegistrationProcess",
        "dictionary.registeredButNotActive",
        "dictionary.userAlreadyPresentInPlatform",
        "dictionary.mailAlreadyAssociated",
        "dictionary.ohNo",
        "dictionary.registrationSomethingWentWrong",
        "dictionary.resendEmail",
        "dictionary.close",
        "dictionary.sentMailSuccessfully",
        "dictionary.checkMailboxToCompleteChangePassword",
        "dictionary.changePasswordSuccessfully",
        "dictionary.changePasswordError",
        "dictionary.changePasswordExpired",
        "dictionary.changePasswordNotFound",
        "dictionary.userNotFoundOrWrongCredentials",
        "dictionary.someUserAlreadyAssociated",
        "dictionary.allUserAlreadyAssociated",
        "dictionary.invitationsSendSuccessfully",
        "dictionary.invitationSendSuccessfully",
        "dictionary.userAlreadyAssociated",
        "dictionary.operationSuccessfully",
        "dictionary.emailSentSuccessfully",
        "dictionary.userNotFoundOrNotValid",
        "dictionary.mandatoryTextField",
        "dictionary.wrongConfigurationFileFormat",
        "dictionary.somethingWentWrongSubText",
        "dictionary.uploadedSuccessfully",
        "dictionary.somethingWentWrongSubText",
        "dictionary.toLogInResetPassword",
        "dictionary.sentEmailHowToResetPassword",
        "dictionary.taxCodeDuplicated",
        "dictionary.taxCodeEmpty",
        "dictionary.taxCodeBadFormat",
        "dictionary.VATDuplicated",
      ])
      .subscribe((translation) => {
        this._lblTaxCodeDuplicated =
          translation["dictionary.taxCodeDuplicated"];
        this._lblVATDuplicated = translation["dictionary.VATDuplicated"];
        this._lblTaxCodeEmpty = translation["dictionary.taxCodeEmpty"];
        this._lblTaxCodeBadFormat = translation["dictionary.taxCodeBadFormat"];
        this._lblIpNotAllowedForConnectionMessage =
          translation["dictionary.ipNotAllowedForConnectionMessage"];
        this._lblExit = translation["dictionary.exit"];
        this._lblConfirm = translation["dictionary.confirm"];
        this._lblUndo = translation["dictionary.undo"];
        this._lblValue = translation["dictionary.value"];
        this._lblOk = translation["dictionary.ok"];
        this._lblUserMustResetPassword =
          translation["dictionary.toLogInResetPassword"];
        this._lblEmailSentResetPassword =
          translation["dictionary.sentEmailHowToResetPassword"];

        this._lblDisconnection = translation["dictionary.disconnection"];
        this._lblDisconnectionSubHeader =
          translation["dictionary.disconnectionTitle"];
        this._lblDisconnectionMessage =
          translation["dictionary.disconnectionMessage"];
        this._lblOps = translation["dictionary.ops"];
        this._lblSomethingWrong = translation["dictionary.somethingWrong"];
        this._lblAttention = translation["dictionary.attention"];
        this._lblDataUpdated = translation["dictionary.updatedData"];
        this._lblCheckConnection = translation["dictionary.checkConnection"];
        this._lblNoOperation = translation["dictionary.noOperation"];
        this._lblAccessResultAllowed =
          translation["dictionary.accessResultAllowed"];
        this._lblAccessResultDeniedExipred =
          translation["dictionary.accessResultDeniedExpiredCard"];
        this._lblAccessResultDeniedNotValidCard =
          translation["dictionary.accessResultDeniedNotValidCard"];
        this._lblAccessResultDeniedWrongTimeslot =
          translation["dictionary.accessResultDeniedWrongTimeslot"];
        this._lblAccessResultDeniedWrongCalendar =
          translation["dictionary.accessResultDeniedWrongCalendar"];
        this._lblAccessResultDeniedLockCard =
          translation["dictionary.accessResultDeniedLockCard"];
        this._lblAccessResultDeniedWrongEnvironment =
          translation["dictionary.accessResultDeniedWrongEnvironment"];
        this._lblAccessResultDenied =
          translation["dictionary.accessResultDenied"];
        this._lblWelcome = translation["dictionary.welcome"];
        this._lblNowYouCanEnter = translation["dictionary.nowYouCanEnter"];
        this._lblCommandNotAvaiable =
          translation["dictionary.commandNotAvaiable"];
        this._lblInteger = translation["dictionary.enterInteger"];
        this._lblFloat = translation["dictionary.enterFloat"];
        this._lblString = translation["dictionary.enterString"];
        this._lblDate = translation["dictionary.chooseDate"];
        this._lblDateTime = translation["dictionary.chooseDateTime"];
        this._lblError = translation["dictionary.error"];
        this._lblNotSupportedRequestUpdate =
          translation["dictionary.notSupportedRequestUpdate"];
        this._lblPleaseEnterPlantName =
          translation["dictionary.pleaseEnterPlantName"];
        this._lblName = translation["dictionary.name"];
        this._lblNamePlantMandatory =
          translation["dictionary.namePlantMandatory"];
        this._lblSomethingWentWrongServerSync =
          translation["dictionary.somethingWentWrongServerSync"];
        this._lblSetUID = translation["dictionary.setUID"];
        this._lblInsertEmail = translation["dictionary.insertEmail"];
        this._lblEmailSuccessfullySent =
          translation["dictionary.emailSuccessfullySent"];
        this._lblCheckInbox = translation["dictionary.checkInbox"];
        this._lblAddressMayNotBeCorrect =
          translation["dictionary.addressMayNotBeCorrect"];
        this._lblEmailNotCorrect = translation["dictionary.emailNotCorrect"];
        this._lblCreateAccount = translation["dictionary.emailCreateAccount"];
        this._lblUserRegisteredSuccessfully =
          translation["dictionary.userRegisteredSuccessfully"];
        this._lblCheckMailboxToCompleteRegistrationProcess =
          translation["dictionary.checkMailboxToCompleteRegistrationProcess"];
        this._lblRegisteredButNotActive =
          translation["dictionary.registeredButNotActive"];
        this._lblUserAlreadyPresentInPlatform =
          translation["dictionary.userAlreadyPresentInPlatform"];
        this._lblMailAlreadyAssociated =
          translation["dictionary.mailAlreadyAssociated"];
        this._lblOhNo = translation["dictionary.ohNo"];
        this._lblRegistrationSomethingWentWrong =
          translation["dictionary.registrationSomethingWentWrong"];
        this._lblResendEmail = translation["dictionary.resendEmail"];
        this._lblClose = translation["dictionary.close"];
        this._lblUserNotFoundOrWrongCredentials =
          translation["dictionary.userNotFoundOrWrongCredentials"];

        this._lblSentMailSuccessfully =
          translation["dictionary.sentMailSuccessfully"];
        this._lblCheckMailboxToCompleteChangePassword =
          translation["dictionary.checkMailboxToCompleteChangePassword"];
        this._lblChangePasswordSuccessfully =
          translation["dictionary.changePasswordSuccessfully"];
        this._lblChangePasswordError =
          translation["dictionary.changePasswordError"];
        this._lblChangePasswordExpired =
          translation["dictionary.changePasswordExpired"];
        this._lblChangePasswordNotFound =
          translation["dictionary.changePasswordNotFound"];
        this._lblSomeUserAlreadyAssociated =
          translation["dictionary.someUserAlreadyAssociated"];
        this._lblAllUserAlreadyAssociated =
          translation["dictionary.allUserAlreadyAssociated"];
        this._lblInvitationsSendSuccessfully =
          translation["dictionary.invitationsSendSuccessfully"];
        this._lblInvitationSendSuccessfully =
          translation["dictionary.invitationSendSuccessfully"];
        this._lblUserAlreadyAssociated =
          translation["dictionary.userAlreadyAssociated"];
        this._lblOperationOk = translation["dictionary.operationSuccessfully"];
        this._lblEmailSentSuccessfully =
          translation["dictionary.emailSentSuccessfully"];
        this._lblUserNotFound =
          translation["dictionary.userNotFoundOrNotValid"];
        this._lblTextMandatory = translation["dictionary.mandatoryTextField"];
        this._lblWrongConfigurationFileFormat =
          translation["dictionary.wrongConfigurationFileFormat"];
        this._lblSomethingWentWrongSubText =
          translation["dictionary.somethingWentWrongSubText"];
        this._lbluploadedSuccessfully =
          translation["dictionary.uploadedSuccessfully"];
        this._lblsomethingWentWrongSubText =
          translation["dictionary.somethingWentWrongSubText"];
      });
  }

  public subscribeTranslationEvent() {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
      }
    );
  }
  //#endregion

  //#region Alert Disconnection
  /**
   * Present alert disconnection
   *
   * @returns alert instances
   */
  public async presentAlertDisconnection(): Promise<void> {
    let btnArray: Array<any> = new Array<any>();

    this._eventService.OnRequestClosingLoader.next(null);
    await this.clearAlertCommandNotAvaiable(); // Closing alert with lower priority

    if (!this._isAlertDisconnectPresented) {
      this._isAlertDisconnectPresented = true;

      if (this._currentClientSetting?.isConnectionLostExitButtonEnabled) {
        btnArray = [
          {
            text: this._lblExit,
            handler: async () => {
              this._eventService.OnMakeForceLogout.next(null);

              await this.clearAlertDisconnection();
            },
          },
        ];
      }

      this._currentDisconnectionAlert = await this._alertController.create({
        header: this._lblDisconnection,
        subHeader: this._lblDisconnectionSubHeader,
        message: this._lblDisconnectionMessage,
        backdropDismiss: false,
        buttons: btnArray,
      });

      await this._currentDisconnectionAlert.present();
    }
  }

  /**
   * Presente alert ok request password
   */
  public async presentAlertOkRequestPassword(): Promise<boolean> {
    let textResultMain: string = "";
    let textResultExtend: string = "";
    let cssClass: string = "";
    let iconResult: string = "";
    let timeoutCloseAlert: number = 3000;

    textResultMain = this._lblSentMailSuccessfully;
    textResultExtend = this._lblCheckMailboxToCompleteChangePassword;
    iconResult = "mail-unread";
    cssClass = "alert-success";

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );

    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
    });

    await this._currentAccessResult.present();

    setTimeout(async () => {
      this.clearAlertAccessResult();
    }, timeoutCloseAlert);

    await this._currentAccessResult.onDidDismiss();

    return true;
  }

  /**
   * Dismiss alert connection if exist
   */
  public async clearAlertDisconnection(): Promise<void> {
    if (this._currentDisconnectionAlert) {
      await this._currentDisconnectionAlert.dismiss();

      this._currentDisconnectionAlert = null;
      this._isAlertDisconnectPresented = false;
    }
  }
  //#endregion

  //#region Alert IP Not allowed
  /**
   * Present alert not connection allowed user
   *
   * @returns
   */
  public async presentAlertIpNotAllowed(): Promise<void> {
    this._eventService.OnRequestClosingLoader.next(null);

    await this.clearAlertCommandNotAvaiable(); // Closing alert with lower priority

    if (!this._isAlertIpNotAllowedPresented) {
      this._isAlertIpNotAllowedPresented = true;

      this._currentIpNotAllowedAddress = await this._alertController.create({
        header: this._lblAttention,
        subHeader: "",
        message: this._lblIpNotAllowedForConnectionMessage,
        backdropDismiss: false,
        buttons: [
          {
            text: this._lblExit,
            handler: async () => {
              this._eventService.OnMakeForceLogout.next(null);

              await this.clearAlertIpNotAllowed();
            },
          },
        ],
      });

      this._currentIpNotAllowedAddress.present();
    }
  }

  /**
   * Clear popup ip not allowed
   */
  public async clearAlertIpNotAllowed(): Promise<void> {
    if (this._currentIpNotAllowedAddress) {
      await this._currentIpNotAllowedAddress.dismiss();

      this._isAlertIpNotAllowedPresented = false;
      this._currentIpNotAllowedAddress = null;
    }
  }
  //#endregion

  //#region Alert Command Not Avaiable
  /**
   * Present alert command not avaiable
   */
  public async presentAlertCommandNotAvaiable(): Promise<void> {
    if (!this._isAlertCommandNotAvaiablePresented) {
      this._isAlertCommandNotAvaiablePresented = true;

      this._currentCommandNotAvaibleAlert = await this._alertController.create({
        header: this._lblAttention,
        message: this._lblCommandNotAvaiable,
        backdropDismiss: false,
        buttons: [
          {
            text: this._lblOk,
            handler: async () => {
              await this.clearAlertCommandNotAvaiable();
            },
          },
        ],
      });

      await this._currentCommandNotAvaibleAlert.present();
    }
  }

  /**
   * Dismiss alert (if exist) command not avaiable
   */
  public async clearAlertCommandNotAvaiable(): Promise<void> {
    if (this._currentCommandNotAvaibleAlert) {
      await this._currentCommandNotAvaibleAlert.dismiss();

      this._currentCommandNotAvaibleAlert = null;
      this._isAlertCommandNotAvaiablePresented = false;
    }
  }
  //#endregion

  /**
   * Show popup alert with only OK button
   *
   * @param title title alert popup
   * @param subTitle sub title alert popup
   * @param messageText content message alert popup
   */
  public async presentAlertOk(
    title: string,
    subTitle: string,
    messageText: string
  ): Promise<boolean> {
    if (!this._isAlertOkPresented) {
      this._isAlertOkPresented = true;

      const alertInstanceOk: HTMLIonAlertElement =
        await this.createGenerateAlertOk(title, subTitle, messageText);
      const data = await alertInstanceOk.onDidDismiss();

      this._currentOkAlert = data.data;
      return this._currentOkAlert;
    } else {
      this._loggerService.log(
        LogLevel.LOG_INFO,
        this._logContext,
        this._logContext,
        "presentAlertOk()",
        "Alert ALREADY present"
      );
      return false;
    }
  }

  /**
   * Clear all popup opened
   */
  public async clearAlertOk(): Promise<void> {
    if (this._isAlertOkPresented) {
      this._isAlertOkPresented = false;
      this._currentOkAlert = null;

      await this._alertController.dismiss();
    }
  }

  /**
   * Present alert data updated
   *
   * @returns
   */
  public async presentAlertDataUpdated(): Promise<boolean> {
    if (!this._isAlertOkPresented) {
      this._isAlertOkPresented = true;

      const alertInstanceOk: HTMLIonAlertElement =
        await this.createGenerateAlertOk(
          this._lblAttention,
          "",
          this._lblDataUpdated
        );

      const { data } = await alertInstanceOk.onDidDismiss();

      this._currentOkAlert = data.values;

      return this._currentOkAlert;
    } else {
      this._loggerService.log(
        LogLevel.LOG_INFO,
        this._logContext,
        this._logContext,
        "presentAlertDataUpdated()",
        "Alert ALREADY present"
      );
      return false;
    }

    //return this._currentOkAlert;
  }

  /**
   *  GF: alert presented when something goes wrong
   */
  public async presentAlertSomethingWrong(): Promise<boolean> {
    if (!this._isAlertOkPresented) {
      this._isAlertOkPresented = true;

      const alertInstanceOk: HTMLIonAlertElement =
        await this.createGenerateAlertOk(
          this._lblOps,
          this._lblSomethingWrong,
          this._lblSomethingWentWrongSubText
        );

      const { data } = await alertInstanceOk.onDidDismiss();
      if (data != undefined) {
        this._currentOkAlert = data.values;
      }
      return this._currentOkAlert;
    } else {
      this._loggerService.log(
        LogLevel.LOG_INFO,
        this._logContext,
        this._logContext,
        "presentAlertSomethingWrong()",
        "Alert ALREADY present"
      );
      return false;
    }
  }

  //
  /**
   *
   * @param title title alert popup
   * @param subTitle sub title alert popup
   * @param messageText content message alert popup
   *
   * Show popup alert with OK and cancel buttons
   *
   */
  public async presentAlertConfirmOrDismiss(
    title: string,
    subTitle: string,
    messageText: string
  ): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      const alert = await this._alertController.create({
        header: title,
        cssClass: "confirm-dismiss-alert",
        subHeader: subTitle,
        message: messageText,
        backdropDismiss: false,
        buttons: [
          {
            text: this._lblUndo,
            role: "cancel",
            handler: () => {
              resolve(false);
            },
          },
          {
            text: this._lblConfirm,
            role: "confirm",
            handler: () => {
              resolve(true);
            },
          },
        ],
      });

      alert.present();
    });
  }

  private createInput(type: string): AlertInput[] {
    let input: AlertInput[] = [];
    switch (type) {
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.INTEGER
      ):
        input[0] = {
          name: "Value",
          type: "number",
          placeholder: this._lblInteger,
        };
        break;
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.FLOAT
      ):
        input[0] = {
          name: "Value",
          type: "number",
          placeholder: this._lblFloat,
        };
        break;
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.TIME
      ):
        input[0] = {
          name: "Value",
          type: "time",
        };
        break;
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.DATE
      ):
        input[0] = {
          name: "Value",
          type: "date",
          placeholder: this._lblDate,
        };
        break;
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.DATETIME
      ):
        input[0] = {
          name: "Value",
          type: "datetime-local",
          placeholder: this._lblDateTime,
        };
        break;
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.BOOLEAN
      ):
        input[0] = {
          name: "Value",
          type: "radio",
          label: "0",
          value: "0",
          checked: true,
        };
        input[1] = {
          name: "Value",
          type: "radio",
          label: "1",
          value: "1",
        };
        break;
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.BYTE_ARRAY
      ):
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.CHAR
      ):
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.STRING
      ):
      default:
        input[0] = {
          name: "Value",
          type: "text",
          placeholder: this._lblString,
        };
        break;
    }
    return input;
  }

  private checkValue(data: any, inputType: string): any {
    switch (inputType) {
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.INTEGER
      ):
        return data.Value == "" ||
          data.Value.includes(",") ||
          data.Value.includes(".")
          ? ""
          : data;
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.DATE
      ):
        if (data.Value != "") {
          data.Value = this._datePipe.transform(
            new Date(data.Value),
            "dd-MM-YYYY"
          );
          return data;
        } else {
          return "";
        }
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.DATETIME
      ):
        if (data.Value != "") {
          data.Value = this._datePipe.transform(
            new Date(data.Value),
            "dd-MM-YYYY hh:mm"
          );
          return data;
        } else {
          return "";
        }
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.BOOLEAN
      ):
        data = {
          Value: data[0],
        };
        return data;
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.FLOAT
      ):
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.TIME
      ):
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.BYTE_ARRAY
      ):
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.STRING
      ):
      case EnumStringConverter.hiLevelDataFormatToStringEnum(
        HiLevelDataFormat.CHAR
      ):
      default:
        return data;
    }
  }

  /**
   * Show popup alert asking a value to the user
   * @param title  title alert popup
   * @param subTitle sub title alert popup
   * @param messageText content message alert popup
   */
  public async presentPrompt(
    title: string,
    subTitle: string,
    messageText: string,
    inputType: string = "",
    inputMandatory: boolean = false
  ): Promise<boolean | string> {
    let inputs = this.createInput(inputType);
    return new Promise((resolve, reject) => {
      this._alertController
        .create({
          header: title,
          subHeader: subTitle,
          message: messageText,
          backdropDismiss: false,
          inputs: inputs,
          buttons: [
            {
              text: this._lblUndo,
              role: "cancel",
              handler: () => {
                resolve(false);
              },
            },
            {
              text: this._lblConfirm,
              role: "confirm",
              handler: (data) => {
                let dataToSend = this.checkValue(data, inputType);

                let proceed = true;
                if (inputMandatory) {
                  if (dataToSend.Value == "" || dataToSend.Value == undefined) {
                    proceed = false;
                    const elements =
                      document.getElementsByClassName("validation-errors");
                    while (elements.length > 0) {
                      elements[0].parentNode.removeChild(elements[0]);
                    }
                    const input =
                      document.getElementsByClassName("alert-input")[0];
                    const validationErrors = document.createElement("div");
                    validationErrors.className = "validation-errors";
                    const errorMessage = document.createElement("small");
                    errorMessage.textContent = this._lblTextMandatory;
                    errorMessage.style.color = "red";
                    validationErrors.appendChild(errorMessage);
                    input.insertAdjacentElement("afterend", validationErrors);

                    return false;
                  }
                }
                if (proceed) {
                  resolve(dataToSend.Value);
                }
              },
            },
          ],
        })
        .then((alert) => {
          alert.present();
          if (inputMandatory) {
            const inputElement = alert.querySelector(".alert-input");

            inputElement.addEventListener("input", (event) => {
              const elements =
                document.getElementsByClassName("validation-errors");
              while (elements.length > 0) {
                elements[0].parentNode.removeChild(elements[0]);
              }
            });
          }
        });
    });
  }

  /**
   *  Show alert to insert mandatory plant name; return name inserted.
   */
  public async showAlertPlantName(
    plantConfiguration: PlantConfigurationExternal
  ): Promise<string> {
    //this._alertController?.dismiss();

    let cnt: AlertController;

    return new Promise((resolve, reject) => {
      let plantNameCustom: string = "";
      this._alertController
        .create({
          backdropDismiss: false,
          subHeader: this._lblPleaseEnterPlantName,
          inputs: [
            {
              placeholder: this._lblName,
            },
          ],
          buttons: [
            {
              text: this._lblConfirm,
              handler: (data) => {
                if (data[0] != "") {
                  plantNameCustom = data[0];
                  //return true;
                  resolve(plantNameCustom);
                } else {
                  const elements =
                    document.getElementsByClassName("validation-errors");
                  while (elements.length > 0) {
                    elements[0].parentNode.removeChild(elements[0]);
                  }

                  //const input = this._currentPlantNameInsertAlert.getElementsByTagName("input")[0];

                  const input =
                    document.getElementsByClassName("alert-input")[0];
                  const validationErrors = document.createElement("div");
                  validationErrors.className = "validation-errors";
                  const errorMessage = document.createElement("small");
                  errorMessage.textContent = this._lblNamePlantMandatory;
                  errorMessage.style.color = "red";
                  validationErrors.appendChild(errorMessage);
                  input.insertAdjacentElement("afterend", validationErrors);

                  return false;
                }
              },
            },
          ],
        })
        .then((alert) => {
          alert.present();
        });
    });
  }

  /**
   *  Show alert UID
   */
  public async showAlertSetUID(carduid): Promise<string> {
    let cnt: AlertController;

    return new Promise((resolve, reject) => {
      let UID: string = "";
      this._alertController
        .create({
          backdropDismiss: false,
          subHeader: this._lblSetUID,
          inputs: [
            {
              value: carduid,
            },
          ],
          buttons: [
            {
              text: this._lblUndo,
              role: "cancel",
              handler: () => {
                reject();
              },
            },
            {
              text: this._lblConfirm,
              handler: (data) => {
                UID = data[0];
                resolve(UID);
              },
            },
          ],
        })
        .then((alert) => {
          alert.present();
        });
    });
  }

  /**
   *  Show prompt to insert email and retrieve password
   */
  public async showPromptInsertEmailForRetrievePassword(): Promise<string> {
    let cnt: AlertController;
    let errorMessage: HTMLElement;

    return new Promise((resolve, reject) => {
      let email: string = "";
      this._alertController
        .create({
          backdropDismiss: false,
          subHeader: this._lblInsertEmail,
          inputs: [
            {
              value: "",
            },
          ],
          buttons: [
            {
              text: this._lblUndo,
              role: "cancel",
              handler: () => {
                reject();
              },
            },
            {
              text: this._lblConfirm,
              handler: (data) => {
                email = data[0];
                if (AppSettings.PATTERN_EMAIL.test(email)) {
                  resolve(email);
                } else {
                  const source =
                    document.getElementsByClassName("alert-input")[0];
                  const inputHandler = function (e) {
                    errorMessage.textContent = "";
                  };
                  source.addEventListener("input", inputHandler);

                  const elements =
                    document.getElementsByClassName("validation-errors");
                  while (elements.length > 0) {
                    elements[0].parentNode.removeChild(elements[0]);
                  }
                  const input =
                    document.getElementsByClassName("alert-input")[0];
                  const validationErrors = document.createElement("div");
                  validationErrors.className = "validation-errors";
                  errorMessage = document.createElement("small");
                  errorMessage.textContent = this._lblEmailNotCorrect;
                  errorMessage.style.color = "red";
                  validationErrors.appendChild(errorMessage);
                  input.insertAdjacentElement("afterend", validationErrors);
                  return false;
                }
              },
            },
          ],
        })
        .then((alert) => {
          alert.present();
        });
    });
  }

  /**
   * Show popup alert for choosing period
   * @param title  title alert popup
   * @param subTitle sub title alert popup
   */
  public async presentPopupChoosePeriod(
    title: string,
    subTitle: string,
    firstDate: Date,
    endDate: Date
  ): Promise<boolean | string> {
    const input = { data: [] };
    input.data.push({
      name: "startDate",
      type: "date",
      label: "Data inziale",
    });

    input.data.push({
      name: "endDate",
      type: "date",
      label: "Data finale",
    });

    return new Promise((resolve, reject) => {
      this._alertController
        .create({
          header: title,
          subHeader: subTitle,
          inputs: input.data,
          backdropDismiss: false,
          buttons: [
            {
              text: this._lblUndo,
              role: "cancel",
              handler: () => {
                resolve(false);
              },
            },
            {
              text: this._lblConfirm,
              role: "confirm",
              handler: (data) => {
                resolve(data);
              },
            },
          ],
        })
        .then((alert) => {
          alert.present();
        });
    });
  }

  /**
   * Present alert feedback virtual access
   *
   * @returns
   */
  public async presentAlertAccessResult(
    AccessResultResponse: AccessResult
  ): Promise<void> {
    if (!this._isAlertAccessResultPresented) {
      this._isAlertAccessResultPresented = true;

      let textAccessResultMain: string = "";
      let textAccessResultExtend: string = "";
      let iconAccessResult: string = "";
      let cssClass: string = "";
      let timeoutCloseAlert: number = 4000;

      switch (AccessResultResponse) {
        case AccessResult.ACCESS_ALLOWED:
          iconAccessResult = "lock-open";
          textAccessResultMain = this._lblAccessResultAllowed;
          textAccessResultExtend =
            this._lblWelcome + "," + this._lblNowYouCanEnter;
          cssClass = "alert-success";
          timeoutCloseAlert = 2000;
          break;
        case AccessResult.ACCESS_DENIED_EXPIRED_CARD:
          iconAccessResult = "time";
          textAccessResultMain = this._lblAccessResultDenied;
          textAccessResultExtend = this._lblAccessResultDeniedExipred;
          cssClass = "alert-warning";
          break;
        case AccessResult.ACCESS_DENIED_LOCK_CARD:
          iconAccessResult = "lock-closed";
          textAccessResultMain = this._lblAccessResultDenied;
          textAccessResultExtend = this._lblAccessResultDeniedLockCard;
          cssClass = "alert-error";
          break;
        case AccessResult.ACCESS_DENIED_NOT_VALID_CARD:
          iconAccessResult = "time";
          textAccessResultMain = this._lblAccessResultDenied;
          textAccessResultExtend = this._lblAccessResultDeniedNotValidCard;
          cssClass = "alert-warning";
          break;
        case AccessResult.ACCESS_DENIED_WRONG_CALENDAR:
          iconAccessResult = "calendar";
          textAccessResultMain = this._lblAccessResultDenied;
          textAccessResultExtend = this._lblAccessResultDeniedWrongCalendar;
          cssClass = "alert-warning";
          break;
        case AccessResult.ACCESS_DENIED_WRONG_TIMESLOT:
          iconAccessResult = "time";
          textAccessResultMain = this._lblAccessResultDenied;
          textAccessResultExtend = this._lblAccessResultDeniedWrongTimeslot;
          cssClass = "alert-warning";
          break;
        case AccessResult.ACCESS_DENIED:
          iconAccessResult = "hand-right";
          textAccessResultMain = this._lblAccessResultDenied;
          textAccessResultExtend = this._lblAccessResultDeniedWrongEnvironment;
          cssClass = "alert-error";
          break;
        default:
          break;
      }

      const messageToShow: string = this.composeMessageToShowAccessBody(
        iconAccessResult,
        textAccessResultMain,
        textAccessResultExtend
      );

      this._currentAccessResult = await this._alertController.create({
        header: "",
        subHeader: "",
        message: messageToShow,
        backdropDismiss: false,
        cssClass: cssClass,
      });

      await this._currentAccessResult.present();
      setTimeout(async () => {
        this.clearAlertAccessResult();
      }, timeoutCloseAlert);
    }
  }

  public async presentAlertResultInvitation(response: UserInvitationResponse) {
    this._isAlertAccessResultPresented = true;
    let sendingEmail = false;
    let timeoutCloseAlert: number = 3000;
    let textResultMain: string = "";
    let textResultExtend: string = "";

    let iconResult: string = "";
    let cssClass: string = "";

    switch (response) {
      case UserInvitationResponse.NO_EXCEPTION:
        textResultExtend = this._lblOperationOk;

        iconResult = "checkmark-outline";
        cssClass = "alert-success";
        break;
      case UserInvitationResponse.USER_ALREADY_ASSOCIATED:
        textResultMain = "";
        textResultExtend = this._lblUserAlreadyAssociated;

        iconResult = "warning-outline";
        cssClass = "alert-warning";
        break;
      default:
        textResultMain = this._lblOhNo;
        textResultExtend = this._lblSomethingWrong;
        iconResult = "close-circle-outline";
        cssClass = "alert-error";
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );

    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
    });

    await this._currentAccessResult.present();
    setTimeout(async () => {
      this.clearAlertAccessResult();
    }, timeoutCloseAlert);
    await this._currentAccessResult.onDidDismiss();
    return true;
  }

  /**
   * present alert error duplicated
   */
  public async presentAlertSendInvitation(
    response: UserSendInvitationResponse,
    singleUser = false
  ) {
    this._isAlertAccessResultPresented = true;
    let sendingEmail = false;
    let timeoutCloseAlert: number = 3000;
    let textResultMain: string = "";
    let textResultExtend: string = "";

    let iconResult: string = "";
    let cssClass: string = "";

    switch (response) {
      case UserSendInvitationResponse.OK_BUT_DUPLICATED:
        textResultExtend = this._lblSomeUserAlreadyAssociated;

        iconResult = "warning-outline";
        cssClass = "alert-warning";
        break;
      case UserSendInvitationResponse.ALL_DUPLICATED:
        textResultMain = this._lblAllUserAlreadyAssociated;
        if (singleUser) {
          textResultMain = this._lblUserAlreadyAssociated;
        }

        iconResult = "close-outline";
        cssClass = "alert-error";
        break;
      default:
        textResultMain = this._lblOhNo;
        textResultExtend = this._lblSomethingWrong;

        iconResult = "close-circle-outline";
        cssClass = "alert-error";
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );

    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
    });

    await this._currentAccessResult.present();
    setTimeout(async () => {
      this.clearAlertAccessResult();
    }, timeoutCloseAlert);
    await this._currentAccessResult.onDidDismiss();
    return true;
  }

  /**
   * Present alert feedback after request for resend email
   *
   * @param registrationResponse
   * @returns
   */
  public async presentAlertDigitalPlaceResendInvitation(
    registrationResponse: UserLoginRegistrationResponse
  ): Promise<boolean> {
    this._isAlertAccessResultPresented = true;
    let sendingEmail = false;
    let timeoutCloseAlert: number = 3000;
    let textResultMain: string = "";
    let textResultExtend: string = "";

    let iconResult: string = "";
    let cssClass: string = "";
    switch (registrationResponse) {
      case UserLoginRegistrationResponse.NO_EXCEPTION:
        textResultMain = this._lblEmailSentSuccessfully;
        textResultExtend = this._lblCheckMailboxToCompleteRegistrationProcess;

        iconResult = "mail-unread";
        cssClass = "alert-success";
        break;

      case UserLoginRegistrationResponse.GENERIC_ERROR:
        textResultMain = this._lblOhNo;
        textResultExtend = this._lblRegistrationSomethingWentWrong;

        iconResult = "close-circle-outline";
        cssClass = "alert-error";
        break;
      default:
        textResultMain = this._lblOhNo;
        textResultExtend = this._lblSomethingWrong;

        iconResult = "close-circle-outline";
        cssClass = "alert-error";
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );

    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
    });

    await this._currentAccessResult.present();
    setTimeout(async () => {
      this.clearAlertAccessResult();
    }, timeoutCloseAlert);

    return true;
  }

  /**
   * Present alert for creation building
   * @param responseCreationBuilding
   */
  public async presentAlertCreationBuilding(
    responseCreationBuilding: BuildingCreationResponse
  ) {
    let textAlert = "";
    let cssClass = "alert-error";
    let iconResult = "close-circle-outline";
    switch (responseCreationBuilding) {
      case BuildingCreationResponse.TAX_CODE_BAD_FORMAT:
        textAlert = this._lblTaxCodeBadFormat;
        break;
      case BuildingCreationResponse.TAX_CODE_EMPTY:
        textAlert = this._lblTaxCodeEmpty;
        break;
      case BuildingCreationResponse.TAX_CODE_DUPLICATED:
        textAlert = this._lblTaxCodeDuplicated;
        break;
      case BuildingCreationResponse.GENERIC_ERROR:
        textAlert = this._lblSomethingWrong;
        break;
    }
    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textAlert,
      ""
    );
    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
      buttons: [
        {
          text: this._lblClose,
          role: "cancel",
          handler: () => {
            return false;
          },
        },
      ],
    });
    await this._currentAccessResult.present();
  }

  /**
   * Present alert feedback after request of registration
   *
   * @param registrationResponse Registration resoponse received
   * @returns
   */
  public async presentAlertDigitalAccountManage(
    registrationResponse: UserLoginRegistrationResponse,
    email?: String
  ): Promise<boolean> {
    this._isAlertAccessResultPresented = true;
    let sendingEmail = false;
    let timeoutCloseAlert: number = 3000;
    let textResultMain: string = "";
    let textResultExtend: string = "";

    let iconResult: string = "";
    let cssClass: string = "";
    switch (registrationResponse) {
      case UserLoginRegistrationResponse.NO_EXCEPTION:
        textResultMain = this._lblUserRegisteredSuccessfully;
        textResultExtend = this._lblCheckMailboxToCompleteRegistrationProcess;

        iconResult = "mail-unread";
        cssClass = "alert-success";
        break;
      case UserLoginRegistrationResponse.USER_NOT_ACTIVE:
        textResultMain = this._lblRegisteredButNotActive;

        iconResult = "person";
        cssClass = "alert-warning";
        break;

      case UserLoginRegistrationResponse.USER_ALREADY_EXISTS:
        textResultMain = this._lblUserAlreadyPresentInPlatform;
        textResultExtend = this._lblMailAlreadyAssociated;

        iconResult = "people";
        cssClass = "alert-error";
        break;

      case UserLoginRegistrationResponse.USER_NOT_FOUND:
        textResultMain = this._lblUserNotFoundOrWrongCredentials;

        iconResult = "person";
        cssClass = "alert-error";
        break;

      case UserLoginRegistrationResponse.GENERIC_ERROR:
        textResultMain = this._lblOhNo;
        textResultExtend = this._lblRegistrationSomethingWentWrong;

        iconResult = "close-circle-outline";
        cssClass = "alert-error";
        break;
      case UserLoginRegistrationResponse.USER_TAX_CODE_DUPLICATED:
        textResultMain = this._lblTaxCodeDuplicated;

        iconResult = "close-circle-outline";
        cssClass = "alert-error";
        break;
      case UserLoginRegistrationResponse.USER_WITH_SAME_VAT:
        textResultMain = this._lblVATDuplicated;

        iconResult = "close-circle-outline";
        cssClass = "alert-error";
        break;
        /*case UserLoginRegistrationResponse.USER_MUST_RESET_PASSWORD:
        textResultMain = this._lblUserMustResetPassword;

        textResultExtend = this._lblEmailSentResetPassword;

        iconResult = "lock-closed";
        cssClass = "alert-warning";*/
        break;
      default:
        textResultMain = this._lblOhNo;
        textResultExtend = this._lblSomethingWrong;

        iconResult = "close-circle-outline";
        cssClass = "alert-error";
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );
    //|| registrationResponse ==       UserLoginRegistrationResponse.USER_MUST_RESET_PASSWORD
    if (registrationResponse == UserLoginRegistrationResponse.USER_NOT_ACTIVE) {
      if (
        registrationResponse == UserLoginRegistrationResponse.USER_NOT_ACTIVE
      ) {
        this._currentAccessResult = await this._alertController.create({
          header: "",
          subHeader: "",
          message: messageToShow,
          backdropDismiss: false,
          cssClass: cssClass,
          buttons: [
            {
              text: this._lblClose,
              role: "cancel",
              handler: () => {
                return false;
              },
            },
            {
              text: this._lblResendEmail,
              role: "confirm",
              handler: () => {
                sendingEmail = true;
              },
            },
          ],
        });
      } else {
        this._currentAccessResult = await this._alertController.create({
          header: "",
          subHeader: "",
          message: messageToShow,
          backdropDismiss: false,
          cssClass: cssClass,
          buttons: [
            {
              text: this._lblConfirm,
              role: "confirm",
              handler: () => {
                sendingEmail = true;
              },
            },
            {
              text: this._lblClose,
              role: "cancel",
              handler: () => {
                return false;
              },
            },
          ],
        });
      }
    } else {
      //Dismiss alert if it already exists in order to prevent stack of alerts
      const alert = await this._alertController.getTop();
      if (alert) {
        this._alertController.dismiss();
      }

      this._currentAccessResult = await this._alertController.create({
        header: "",
        subHeader: "",
        message: messageToShow,
        backdropDismiss: false,
        cssClass: cssClass,
      });
    }

    await this._currentAccessResult.present();
    //&&  registrationResponse !=      UserLoginRegistrationResponse.USER_MUST_RESET_PASSWORD
    if (registrationResponse != UserLoginRegistrationResponse.USER_NOT_ACTIVE) {
      setTimeout(async () => {
        this.clearAlertAccessResult();
      }, timeoutCloseAlert);
    } else {
    }
    //&&         registrationResponse ==         UserLoginRegistrationResponse.USER_MUST_RESET_PASSWORD
    await this._currentAccessResult.onDidDismiss().then(async (data) => {
      if (sendingEmail) {
        try {
          this._accountService.performDPAccountResetPasswordRequest(
            email["email"]
          );
        } catch (exception) {
          await this.presentAlertSomethingWrong();
        }
      }
      if (
        sendingEmail &&
        registrationResponse == UserLoginRegistrationResponse.USER_NOT_ACTIVE
      ) {
        try {
          let response = await this._accountService.sendEmailActivation(
            email["email"]
          );

          this.presentAlertSendEmailResult(true);
        } catch (exception) {
          await this.presentAlertDigitalAccountManage(
            exception.error.errorCode,
            email
          );
        }
      }
    });

    return true;
  }

  /**
   * Present alert feedback after request of registration
   *
   * @param registrationResponse Registration resoponse received
   * @returns
   */
  public async presentAlertDigitalRequestChangePassword(
    registrationResponse: UserLoginRegistrationResponse,
    email?: String
  ): Promise<boolean> {
    this._isAlertAccessResultPresented = true;
    let sendingEmail = false;
    let timeoutCloseAlert: number = 3000;
    let textResultMain: string = "";
    let textResultExtend: string = "";

    let iconResult: string = "";
    let cssClass: string = "";
    switch (registrationResponse) {
      case UserLoginRegistrationResponse.NO_EXCEPTION:
        textResultMain = this._lblUserRegisteredSuccessfully;
        textResultExtend = this._lblCheckMailboxToCompleteRegistrationProcess;

        iconResult = "mail-unread";
        cssClass = "alert-success";
        break;
      case UserLoginRegistrationResponse.USER_NOT_ACTIVE:
        textResultMain = this._lblRegisteredButNotActive;

        iconResult = "person";
        cssClass = "alert-warning";
        break;

      case UserLoginRegistrationResponse.USER_NOT_FOUND:
        textResultMain = this._lblUserNotFound;

        iconResult = "person";
        cssClass = "alert-error";
        break;

      case UserLoginRegistrationResponse.GENERIC_ERROR:
        textResultMain = this._lblOhNo;
        textResultExtend = this._lblRegistrationSomethingWentWrong;

        iconResult = "close-circle-outline";
        cssClass = "alert-error";
        break;
      default:
        textResultMain = this._lblOhNo;
        textResultExtend = this._lblSomethingWrong;

        iconResult = "close-circle-outline";
        cssClass = "alert-error";
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );
    if (registrationResponse == UserLoginRegistrationResponse.USER_NOT_ACTIVE) {
      this._currentAccessResult = await this._alertController.create({
        header: "",
        subHeader: "",
        message: messageToShow,
        backdropDismiss: false,
        cssClass: cssClass,
        buttons: [
          {
            text: this._lblClose,
            role: "cancel",
            handler: () => {
              return false;
            },
          },
          {
            text: this._lblResendEmail,
            role: "confirm",
            handler: () => {
              sendingEmail = true;
            },
          },
        ],
      });
    } else {
      this._currentAccessResult = await this._alertController.create({
        header: "",
        subHeader: "",
        message: messageToShow,
        backdropDismiss: false,
        cssClass: cssClass,
      });
    }

    await this._currentAccessResult.present();
    if (registrationResponse != UserLoginRegistrationResponse.USER_NOT_ACTIVE) {
      setTimeout(async () => {
        this.clearAlertAccessResult();
      }, timeoutCloseAlert);
    } else {
    }

    await this._currentAccessResult.onDidDismiss().then(async (data) => {
      if (
        sendingEmail &&
        registrationResponse == UserLoginRegistrationResponse.USER_NOT_ACTIVE
      ) {
        try {
          let response = await this._accountService.sendEmailActivation(
            email["email"]
          );

          this.presentAlertSendEmailResult(true);
        } catch (exception) {
          await this.presentAlertDigitalAccountManage(
            exception.error.errorCode,
            email
          );
        }
      }
    });

    return true;
  }

  /**
   * Handle response from reset password
   */
  public async presentAlertDigitalPlaceResetPassword(
    resetPasswordResponse: UserRequestResetPasswordResponse
  ) {
    this._isAlertAccessResultPresented = true;
    let sendingEmail = false;
    let timeoutCloseAlert: number = 3000;
    let textResultMain: string = "";
    let textResultExtend: string = "";

    let iconResult: string = "";
    let cssClass: string = "";
    switch (resetPasswordResponse) {
      case UserRequestResetPasswordResponse.NO_EXCEPTION:
        textResultMain = this._lblChangePasswordSuccessfully;
        textResultExtend = "";

        iconResult = "checkmark-outline";
        cssClass = "alert-success";
        break;
      case UserRequestResetPasswordResponse.REQUEST_EXPIRED:
        textResultMain = this._lblChangePasswordError;
        textResultExtend = this._lblChangePasswordExpired;

        iconResult = "alert-outline";
        cssClass = "alert-error";
        break;

      case UserRequestResetPasswordResponse.REQUEST_NOT_FOUND:
        textResultMain = this._lblChangePasswordError;
        textResultExtend = this._lblChangePasswordNotFound;

        iconResult = "alert-outline";
        cssClass = "alert-error";
        break;
      case UserRequestResetPasswordResponse.GENERIC_ERROR:
      default:
        textResultMain = this._lblOhNo;
        textResultExtend = this._lblSomethingWrong;

        iconResult = "close-circle-outline";
        cssClass = "alert-error";
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );

    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
    });

    await this._currentAccessResult.present();

    setTimeout(async () => {
      this.clearAlertAccessResult();
    }, timeoutCloseAlert);

    await this._currentAccessResult.onDidDismiss();

    return true;
  }

  /**
   * Present alert feedback send invitation
   *
   * @returns
   */
  public async presentAlertSendInvitationResult(
    result: boolean,
    singular: boolean = false
  ): Promise<void> {
    this._isAlertAccessResultPresented = true;

    let textResultMain: string = "";
    let textResultExtend: string = "";
    let iconResult: string = "";
    let cssClass: string = "";
    let timeoutCloseAlert: number = 2500;

    if (result) {
      iconResult = "checkmark-outline";
      if (singular) {
        textResultMain = this._lblInvitationSendSuccessfully;
      } else {
        textResultMain = this._lblInvitationsSendSuccessfully;
      }
      //textResultExtend = this._lblCheckInbox;
      cssClass = "alert-success";
      timeoutCloseAlert = 2500;
    } else {
      iconResult = "close-outline";
      textResultMain = this._lblOps + " " + this._lblSomethingWrong;
      cssClass = "alert-error";
      timeoutCloseAlert = 2500;
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );

    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
    });

    await this._currentAccessResult.present();
    setTimeout(async () => {
      this.clearAlertAccessResult();
    }, timeoutCloseAlert);
  }

  /**
   * Present alert feedback send email for forgot password
   *
   * @returns
   */
  public async presentAlertSendEmailResult(result: boolean): Promise<void> {
    this._isAlertAccessResultPresented = true;

    let textResultMain: string = "";
    let textResultExtend: string = "";
    let iconResult: string = "";
    let cssClass: string = "";
    let timeoutCloseAlert: number = 2500;

    if (result) {
      iconResult = "checkmark-outline";
      textResultMain = this._lblEmailSuccessfullySent;
      textResultExtend = this._lblCheckInbox;
      cssClass = "alert-success";
      timeoutCloseAlert = 2500;
    } else {
      iconResult = "close-outline";
      textResultMain = this._lblOps + " " + this._lblSomethingWrong;
      textResultExtend = this._lblAddressMayNotBeCorrect;
      cssClass = "alert-error";
      timeoutCloseAlert = 2500;
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );

    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
    });

    await this._currentAccessResult.present();
    setTimeout(async () => {
      this.clearAlertAccessResult();
    }, timeoutCloseAlert);
  }

  /**
   * Clear popup access result
   */
  public async clearAlertAccessResult(): Promise<void> {
    if (this._currentAccessResult) {
      this._isAlertAccessResultPresented = false;

      await this._currentAccessResult.dismiss();
      this._currentAccessResult = null;
    }
  }

  /**
   * Show Alert error with specific specific message
   *
   * @param errorMessage Error message
   */
  public async showAlertError(errorMessage: string): Promise<void> {
    await this.presentAlertOk(this._lblError, "", errorMessage);
  }

  public async showAlertUnsupportedFeature(): Promise<void> {
    await this.showAlertError(this._lblNotSupportedRequestUpdate);
  }

  public async showAlertErrorServerSync(): Promise<void> {
    await this.showAlertError(this._lblSomethingWentWrongServerSync);
  }

  /**
   * Alert controller for uploading wrong configuration file format
   * @returns Promise of type boolean
   */
  public async presentAlertWrongFileFormat(): Promise<boolean> {
    if (!this._isAlertOkPresented) {
      this._isAlertOkPresented = true;

      const alertInstanceOk: HTMLIonAlertElement =
        await this.createGenerateAlertOk(
          this._lblOps,
          "",
          this._lblWrongConfigurationFileFormat
        );

      const { data } = await alertInstanceOk.onDidDismiss();
      if (data != undefined) this._currentOkAlert = data.values;
      return this._currentOkAlert;
    } else {
      return false;
    }
  }

  /**
   * Present an alert controller for equipments and associated properties upload
   *
   * @returns
   */
  public async presentAlertEquipmentUploaded(result: boolean): Promise<void> {
    this._isAlertAccessResultPresented = true;

    let textResultMain: string = "";
    let textResultExtend: string = "";
    let iconResult: string = "";
    let cssClass: string = "";
    let timeoutCloseAlert: number = 2500;

    if (result) {
      iconResult = "checkmark-outline";
      textResultMain = this._lbluploadedSuccessfully;
      cssClass = "alert-success-dp";
      timeoutCloseAlert = 1000;
    } else {
      iconResult = "close-outline";
      textResultMain = this._lblOps + " " + this._lblSomethingWrong;
      textResultExtend = this._lblSomethingWentWrongSubText;
      cssClass = "alert-error";
      timeoutCloseAlert = 5000;
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );

    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
    });

    await this._currentAccessResult.present();
    setTimeout(async () => {
      this.clearAlertAccessResult();
    }, timeoutCloseAlert);
  }

  /**
   *  Show alert on create or update quote; based on whether the operation was successful or not
   * @param result boolean
   * @param message  the message to show
   * @param errorMsg  the error message to show
   */
  public async presentAlertBillsQuotesCorrespondingMsg(
    result: boolean,
    message: string,
    errorMsg?: string
  ): Promise<void> {
    this._isAlertAccessResultPresented = true;

    let textResultMain: string = "";
    let textResultExtend: string = "";
    let iconResult: string = "";
    let cssClass: string = "";
    let timeoutCloseAlert: number = 2500;

    if (result) {
      iconResult = "checkmark-outline";
      textResultMain = message;
      cssClass = "alert-success-dp";
      timeoutCloseAlert = 1500;
    } else {
      iconResult = "close-outline";
      textResultMain = this._lblOps + " " + this._lblSomethingWrong;
      textResultExtend = errorMsg
        ? errorMsg
        : this._lblSomethingWentWrongSubText;
      cssClass = "alert-error";
      timeoutCloseAlert = 5000;
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );

    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
    });

    await this._currentAccessResult.present();
    setTimeout(async () => {
      this.clearAlertAccessResult();
    }, timeoutCloseAlert);
  }

  /**
   * Present an alert controller for consumption management
   *
   * @returns
   */
  public async presentAlertConsumptionManagement(
    result: boolean
  ): Promise<void> {
    this._isAlertAccessResultPresented = true;

    let textResultMain: string = "";
    let textResultExtend: string = "";
    let iconResult: string = "";
    let cssClass: string = "";
    let timeoutCloseAlert: number = 2500;

    if (result) {
      iconResult = "checkmark-outline";
      cssClass = "alert-success-dp";
      timeoutCloseAlert = 1000;
    } else {
      iconResult = "close-outline";
      textResultMain = this._lblOps + " " + this._lblSomethingWrong;
      textResultExtend = this._lblSomethingWentWrongSubText;
      cssClass = "alert-error";
      timeoutCloseAlert = 5000;
    }

    const messageToShow: string = this.composeGenericMessageToShowResult(
      iconResult,
      textResultMain,
      textResultExtend
    );

    this._currentAccessResult = await this._alertController.create({
      header: "",
      subHeader: "",
      message: messageToShow,
      backdropDismiss: false,
      cssClass: cssClass,
    });

    await this._currentAccessResult.present();
    setTimeout(async () => {
      this.clearAlertAccessResult();
    }, timeoutCloseAlert);
  }

  /**
   * Create general instance of alert Ok service
   *
   * @param title Title alert
   * @param subTitle Subtitle alert
   * @param message Message alert
   * @returns
   */
  private async createGenerateAlertOk(
    title: string,
    subTitle: string,
    message: string
  ): Promise<HTMLIonAlertElement> {
    const alertOKInstance: HTMLIonAlertElement =
      await this._alertController.create({
        header: title,
        subHeader: subTitle,
        message: message,
        backdropDismiss: false,
        cssClass: "create-generate-alert-ok",
        buttons: [
          {
            text: this._lblOk,
            handler: async () => {
              await this.clearAlertOk();
              return {
                values: true,
              };
            },
          },
        ],
      });

    await alertOKInstance.present();

    return alertOKInstance;
  }

  /**
   * Compose html body for showing message access to show
   *
   * @param icon Icon message
   * @param textMain Main text to assign to body
   * @param textExtended Extended text to assign to body
   * @returns HTML string
   */
  private composeMessageToShowAccessBody(
    icon: string,
    textMain: string,
    textExtended: string
  ): string {
    return (
      "<div class='container-popup-access-result'><div class='container-icon-access-result'><ion-icon name='" +
      icon +
      "'></ion-icon></div><ion-text class='access-result-text-main'>" +
      textMain +
      "</ion-text>" +
      " <ion-text class='access-result-main-text-extended'>" +
      textExtended +
      "</ion-text></ion-grid>"
    );
  }

  /**
   * Compose html body for showing message for sent email after creatin account
   *
   * @param icon Icon message
   * @param textMain Main text to assign to body
   * @param textExtended Extended text to assign to body
   * @returns HTML string
   */
  private composeGenericMessageToShowResult(
    icon: string,
    textMain: string,
    textExtended: string
  ): string {
    let content: string = "";
    content =
      "<div class='container-popup-access-result'><div class='container-icon-access-result'><ion-icon name='" +
      icon +
      "'></ion-icon></div><ion-text class='access-result-text-main-user'>" +
      textMain +
      "</ion-text>" +
      " <ion-text class='access-result-main-text-extended'>" +
      textExtended +
      "</ion-text></ion-grid>";

    return content;
  }

  /**
   * Compose html body for showing message for sent email
   *
   * @param icon Icon message
   * @param textMain Main text to assign to body
   * @param textExtended Extended text to assign to body
   * @returns HTML string
   */
  private composeMessageToShowResultEmail(
    icon: string,
    textMain: string,
    textExtended: string
  ): string {
    return (
      "<div class='container-popup-access-result'><div class='container-icon-access-result'><ion-icon name='" +
      icon +
      "'></ion-icon></div><ion-text class='access-result-text-main'>" +
      textMain +
      "</ion-text>" +
      " <ion-text class='access-result-main-text-extended'>" +
      textExtended +
      "</ion-text></ion-grid>"
    );
  }

  /**
   * Subscribe to client settings list
   */
  private subscribeSettingServiceData(): void {
    this._selectClientSettingsUserSub = this._store
      .select(clientSettings)
      .pipe(filter((clientSetting) => clientSetting !== null))
      .subscribe((clientSettings: ClientSettings) => {
        this._currentClientSetting = clientSettings;
      });
  }

  //#region Unsubscribe from "_store.selec(...)" Observable
  /**
   * This method handles the unsunìbscription from the Observables returned by the "_store.select(...)" invocations.
   * It SHOULD BE CALLED EACH TIME THE DATA STREAMS ARE NOT NEEDED ANYMORE; this means in:
   *
   * * OnDestroy() [Components/Services]
   * * OnViewWillLeave() [Pages]
   */
  private unsubscribeStoreSelect(): void {
    if (this._selectClientSettingsUserSub) {
      this._selectClientSettingsUserSub.unsubscribe();
    }
  }
  //#endregion
}
